<template>
    <div v-if="!!packages.length && !!value" class="package-picker">
        <h6>{{ $root.translate("Asset Packages") }}</h6>
        <div class="form-input-hint">{{ $root.translate("Select at least one package") }}</div>

        <div class="columns">
            <div
                v-for="pkg in packages"
                :key="pkg.id"
                class="column col-6 col-sm-12 mb-5"
            >
                <switch-input
                    :name="`pkg-${pkg.id}`"
                    :checked="value.indexOf(pkg.id) >= 0"
                    :editable="editable && ((value.length > 1) || (value.indexOf(pkg.id) < 0)) && (pkg.is_public || is_at_least_assistant)"
                    @input="toggle_package(pkg.id)"
                >
                    {{ pkg.name }}
                </switch-input>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import utilities from "../mixins/Is"

import { SwitchInput } from "../library"

// value is array of ids

export default {
    name: "PackagePicker",
    mounted () {
        if(!this.packages_loaded) {
            this.$store.dispatch(
                "FETCH_RECORDS",
                {
                    entity: "package",
                    query: { public: true }
                }
            ).then(() => {
                this.packages_loaded = true
            })
        }
    },
    mixins: [utilities],
    components: {
        SwitchInput
    },
    methods: {
        toggle_package (package_id) {
            const package_ids = [...this.value]
            const index = package_ids.indexOf(package_id)
            if(index >= 0) {
                package_ids.splice(index, 1)
                if(!package_ids.length) return
            } else package_ids.push(package_id)
            this.$emit("input", package_ids)
        }
    },
    computed: {
        ...mapGetters({
            entity_records: "entity_records"
        }),
        raw_package_records () {
            return this.entity_records("package")
        },
        packages () {
            return orderBy(this.raw_package_records, "name", "asc")
        }
    },
    props: {
        value: {
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            packages_loaded: false
        }
    }
}
</script>
